import { Pipe, PipeTransform } from '@angular/core';

import { CorrelationMetric } from '../services/metric.service';

@Pipe({
  name: 'filterCorrelationMetric',
  standalone: true
})
export class FilterCorrelationMetricPipe implements PipeTransform {

  public transform(value: CorrelationMetric[], searchValue: string): CorrelationMetric[] {
    if (!searchValue || searchValue.length < 3) {
      return value;
    }
    const pattern = new RegExp('\\b' + searchValue.toLocaleLowerCase());
    return value.filter((metric: CorrelationMetric) => pattern.test(metric.alternateTitle.toLocaleLowerCase()));
  }
}
